import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Card, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { WABA_SETTINGS_API } from '../utils/api';
import Navbar from '../components/Navbar';

export default function WabaSettings() {
  const [loading, setLoading] = useState(true);
  const [noData, setNoData] = useState(false);
  const [active, setActive] = useState(false);
  const [form, setForm] = useState({
    apiKey: '',
    senderNumber: '',
    templateId: ''
  });

  const token = localStorage.getItem('token');
  const customer_id = JSON.parse(atob(token)).customer_id;

  useEffect(() => {
    fetchWabaSettings();
  }, []);

  const fetchWabaSettings = async () => {
    try {
      const res = await axios.post(WABA_SETTINGS_API, {
        customer_id,
        token,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success && res.data.data) {
        const { active_status, api_key, sender_number, template_id } = res.data.data;

        const hasData = api_key || sender_number || template_id;
        if (!hasData) {
          setNoData(true);
        }

        setForm({
          apiKey: api_key,
          senderNumber: sender_number,
          templateId: template_id
        });
        setActive(active_status === '1' || active_status === 1);
      } else {
        setNoData(true);
      }
    } catch (err) {
      console.error('Error loading WABA settings:', err);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  const isComplete = (value) => value?.trim() !== '';

  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
        <div>Loading WABA Configuration...</div>
      </div>
    );
  }

  if (noData) {
    return (
      <div className="container mt-4">
        <h3 className="mb-4">📤 WhatsApp Configuration</h3>
        <Alert variant="warning">⚠️ No WABA configuration found for this customer. For Activation Please contact to your service provider</Alert>
      </div>
    );
  }

  return (
    <>
    <Navbar/>
    <div className="container mt-4">
      <h3 className="mb-4">📤 WhatsApp Configuration</h3>

      <Card className="shadow p-4">
        <Form>
          <Form.Check
            type="switch"
            id="waba-switch"
            label={active ? '✅ WABA Active' : '❌ WABA Inactive, Contact your service provider for it'}
            checked={active}
            disabled
            readOnly
            className="mb-4"
          />

          <Row className="mb-3 align-items-center">
            <Col md={4}><Form.Label>🔑 API Key</Form.Label></Col>
            <Col md={6}>
              <Form.Control
                type="text"
                name="apiKey"
                value={form.apiKey}
                readOnly
                plaintext
              />
            </Col>
            <Col md={2} className="text-center">
              {isComplete(form.apiKey) ? '✅' : '❌'}
            </Col>
          </Row>

          <Row className="mb-3 align-items-center">
            <Col md={4}><Form.Label>📱 Phone ID</Form.Label></Col>
            <Col md={6}>
              <Form.Control
                type="text"
                name="senderNumber"
                value={form.senderNumber}
                readOnly
                plaintext
              />
            </Col>
            <Col md={2} className="text-center">
              {isComplete(form.senderNumber) ? '✅' : '❌'}
            </Col>
          </Row>

          <Row className="mb-4 align-items-center">
            <Col md={4}><Form.Label>🧩 WABA ID</Form.Label></Col>
            <Col md={6}>
              <Form.Control
                type="text"
                name="templateId"
                value={form.templateId}
                readOnly
                plaintext
              />
            </Col>
            <Col md={2} className="text-center">
              {isComplete(form.templateId) ? '✅' : '❌'}
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
    </>
  );
}
